import { ChatBotTemplateAPI } from "./ChatBotTemplateAPI";
import { AiMbrAPI } from "./AiMbrAPI";
// import { ProductGPTAPI } from "./ProductGPTAPI";
import {UploadFolderModalAPI} from "./UploadFolderModalAPI";
import {AutoCoderUploadFolderModalAPI} from "./AutoCoderUploadFolderModalApi";
import {AutoCoderChatBotTemplateAPI} from "./AutoCoderChatBotTemplateAPI";
export const chatBotTemplateAPI = new ChatBotTemplateAPI();
export const aiMbrAPI = new AiMbrAPI();
export const uploadFolderModalAPI= new UploadFolderModalAPI();
export const autoCoderUploadFolderModalAPI = new AutoCoderUploadFolderModalAPI();
export const autoCoderChatBotTemplateAPI = new AutoCoderChatBotTemplateAPI();

// export const productGPTAPI = new ProductGPTAPI();

